import React from 'react'

import Navigation from '../components/navigation/Navigation'

interface Props {
    role: String
};
interface State {
    error: String | null,
    isLoading: Boolean
};

export default class NotFoundPage extends React.Component<Props, State>
{
    constructor(props: Props) 
    {
        super(props)
        
        this.state = {
            error: null,
            isLoading: false
        }
    }

    componentDidMount() {
    }

    render() {
        const { error, isLoading } = this.state
        
        return (
            <div className="render-home">
                <Navigation role={this.props.role}/>
                <div className="container">
                    <div style={{fontSize:'5rem', color: '#2D2D2D', fontWeight: 'bold',width: '100%', textAlign:'center', padding:'2rem'}}>
                        404 - Not found
                    </div>
                    <div style={{textAlign:'center', color:'#2D2D2D', fontSize:'1.5rem'}}>Vilse? sånt händer, gå till vår <a href="/">startsida</a></div>
                </div>
            </div>
        )
    }
}
